import { render } from "./DespedidaNotFound.vue?vue&type=template&id=fc6c1e42&scoped=true"
import script from "./DespedidaNotFound.vue?vue&type=script&lang=js"
export * from "./DespedidaNotFound.vue?vue&type=script&lang=js"

import "./DespedidaNotFound.vue?vue&type=style&index=0&id=fc6c1e42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc6c1e42"]])

export default __exports__